/* RuleSeverityEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
// const { typeLabelsList, getTypeData, typeDataByLabel } = require("../CustomFieldsConstants");
const CommonEditor = require("./CommonEditor");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

class RuleSeverityEditor extends CommonEditor {
    constructor(args) {
        super(args);
        this.rootElement.classList.add("select");
        this.rootElement.classList.add("severity-editor");
        // this._maxSortOrder = 0;
        this._grid = args.grid;
        const sevMap = this._itemData && this._itemData.sevMap;
        this.input.setOptions(
            Object.keys(sevMap).map((key) => {
                return {
                    label: sevMap[key],
                    value: key
                };
            })
        );
    }

    applyValue(item, state) {
        // console.log(item, state);
        super.applyValue(item, state);
        console.log(item, state);
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        const combobox = new SingleComboBoxControl({
            showFilter: false,
            darkTheme: false,
            adjustWidth: true,
            allowClear: false
        });
        return combobox;
    }
}

module.exports = RuleSeverityEditor;
